import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { DrugStudy } from "./drug-study";

@staticImplements<ResponseModelInterfaceStatic>()
export class DrugHead
{
    public constructor(
        public atcs: string[],
        public name: string,
        public activeSubstances: string[],
        public description: string,
        public tdmStrategy: string,
        public study: DrugStudy,
        public comments: string[],
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): DrugHead
    {
        const drug = elem.firstChildByTag("drug");

        return new this(
            drug.firstChildByTag("atcs").translatedElemValues("atc"),
            drug.firstChildByTag("drugName").translatedElemValue("name"),
            drug.firstChildByTag("activeSubstances").translatedElemValues("activeSubstance"),
            drug.firstChildByTag("drugDescription").translatedElemValue("desc"),
            drug.firstChildByTag("tdmStrategy").translatedElemValue("text"),
            DrugStudy.makeFromXml(elem.firstChildByTag("study")),
            elem.firstChildByTag("comments").translatedElemValues("comment"),
        );
    }
}
